import * as React from 'react';

import { PropertySimilar } from '@shared-ui/lodging-property-details';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './details/shared-ui-property-details';

const SimilarPropertiesWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => (
  <UitkSpacing margin={{ block: 'three', small: { inline: 'three' }, medium: { inline: 'unset' } }}>
    <div>
      <PropertySimilar inputs={inputs} />
    </div>
  </UitkSpacing>
);

export const SharedUiSimilarPropertiesWrapper = withSharedUiPropertyDetails(SimilarPropertiesWrapper);
SharedUiSimilarPropertiesWrapper.displayName = 'SharedUiSimilarPropertiesWrapper';
